const { Core, Events } = Global;

const CN_LOADING = '!loading';
const ATTR_VARIANT_ID = 'variant-id';

customElements.define('product-to-cart', class extends Core {
    elements = {
        $: ['to-cart-button']
    }

    propTypes = {
        'form-child': Boolean
    }

    render() {
        this.$({ click: this._onClick });
        this.sub(Events.CART_UPDATE, this._cartUpdateHandler, { global: true });
        this.sub(Events.CART_ERROR, this._cartUpdateHandler, { global: true });
    }

    _onClick(e) {
        if (!this.prop('form-child')) {
            e.preventDefault();
        }

        if (!this.variantId || Number.isNaN(this.variantId)) {
            console.error('product-to-cart: missing or invalid variant-id');
            return;
        }

        this.loading = true;

        if (!this.prop('form-child')) {
            this.addToCart(this.cartItem);
        }
    }

    addToCart(items) {
        this.pub(Events.CART_ADD, {
            items
        });
    }

    _cartUpdateHandler() {
        setTimeout(() => {
            this.loading = false;
        }, 500);
    }

    get cartItem() {
        const qtyInput =
            this.closest('product-form')?.querySelector('[name="quantity"]') ||
            this.closest('form')?.querySelector('[name="quantity"]');

        const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);

        return [{
            id: this.variantId,
            quantity
        }];
    }

    set loading(state) {
        const btn = this.$('to-cart-button');
        if (btn) btn.classList.toggle(CN_LOADING, state);
    }

    set variantId(id) {
        this.setAttribute(ATTR_VARIANT_ID, id);
    }

    get variantId() {
        return +this.getAttribute(ATTR_VARIANT_ID);
    }
});